
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"#6C7684","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.334 1.335h-.667V.668h-2v.667H5.334V.668h-2v.667h-.667a2 2 0 00-2 2v10a2 2 0 002 2h10.667a2 2 0 002-2v-10a2 2 0 00-2-2zm0 12H2.667v-10h.667V4h2v-.666h5.333V4h2v-.666h.667v10z"}}),_c('path',{attrs:{"d":"M9.334 6.004H6.667V8.67h2.667V6.004zM9.334 9.336H6.667v2.667h2.667V9.336zM12.667 6.004h-2.666V8.67h2.666V6.004zM6 6.004H3.335V8.67h2.667V6.004zM6 9.336H3.335v2.667h2.667V9.336z"}})])
          )
        }
      }
    